import trimEnd from "lodash/trimEnd";
import escapeRegExp from "lodash/escapeRegExp";
import Big from "big.js";
// import i18n from "@/plugins/i18n";

export function getPreferredLanguage(): string {
  // temporarily set default language to eu
  // return i18n.global.locale.value || window.navigator.language || "en";
  /** FIXME: Change to actual preferred language
   *
   * setting to en for now as it's the locale of the UI design
   */
  return "en";
}

/**
 * Get decimal separator for current user locale
 */
export function getDecimalSeparator(): string {
  const n = 1.1;
  return n.toLocaleString(getPreferredLanguage()).substring(1, 2);
}

/**
 * Get the thousand separator for current user locale
 */
export function getThousandSeparator(): string {
  const n = 11111.1; // 11 111.1
  return n.toLocaleString(getPreferredLanguage()).substring(2, 3);
}

/**
 * Parse a big decimal using locale
 */
export interface LocalizedBigParams {
  localizedBigDecimal: string;
  returnZeroOnInvalidInput?: boolean;
  decimalPlaces?: number;
  roundUp?: boolean;
}

export function parselocalizedBigDec({
  localizedBigDecimal,
  returnZeroOnInvalidInput = false,
  decimalPlaces = 0,
  roundUp = false,
}: LocalizedBigParams): string | number {
  const thousandSeparatorRegex = new RegExp(
    escapeRegExp(getThousandSeparator()),
    "g"
  );

  try {
    /** separated rounded big num since
     * adding .round() function in return part
     * causes invalid function error
     */
    const roundedBigNum = new Big(
      trimEnd(
        localizedBigDecimal
          .replace(thousandSeparatorRegex, "")
          .replace(getDecimalSeparator(), "."),
        "."
      )
    )
      .round(decimalPlaces, Big.roundHalfUp)
      .toFixed(decimalPlaces);

    const bigNum = new Big(
      trimEnd(
        localizedBigDecimal
          .replace(thousandSeparatorRegex, "")
          .replace(getDecimalSeparator(), "."),
        "."
      )
    ).toFixed(decimalPlaces);

    return roundUp ? roundedBigNum : bigNum;
  } catch (e) {
    console.log("ERROR in parseLocalizedBigDec: ", e);
    return returnZeroOnInvalidInput ? "0" : NaN;
  }
}

/**
 * ==== BIG DECIMAL FUNCTIONS ====
 *
 * To preserve precision across different operations and locale formatting these
 * functions will be used for display related updates for numbers
 */

/**
 * Use this to format number string when locale is updated
 */
export function formatNumberLocaleDisplay(
  amount: string,
  previousLocale: string
): string {
  const currentLocale = getPreferredLanguage();
  if (currentLocale === previousLocale) return amount;
  const enThousandsMark = ",";
  const enDecimalMark = ".";
  const ruThousandsMark = " ";
  const ruDecimalMark = ",";
  if (previousLocale === "ru") {
    return amount
      .replace(ruDecimalMark, enDecimalMark)
      .replace(ruThousandsMark, enThousandsMark);
  } else if (currentLocale === "ru") {
    return amount
      .replace(enThousandsMark, ruThousandsMark)
      .replace(enDecimalMark, ruDecimalMark);
  }
  return amount;
}

export const decimalToPercentage = (decimal: number | string): number =>
  Number(decimal) * 100;
